import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

const Privacy: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Privacy Policy | Born in YU</title>
        <meta name="description" content="Read Born in YU's privacy policy. Learn how we collect, use, and protect your personal information when shopping for Yugoslav nostalgia apparel." />
        <link rel="canonical" href="https://borninyu.com/privacy" />
      </Helmet>
      <main className="min-h-screen bg-white">
      <section className="p-6 md:p-24">
        <div className="max-w-4xl mx-auto">
          <div className="border-[3px] border-black p-8 md:p-16 relative">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-white px-4 border-[3px] border-black font-black uppercase tracking-widest text-sm">
              {t('privacy.classification')}
            </div>

            <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter mb-8">
              {t('footer.links.privacy')}
            </h1>

            <div className="font-typewriter text-sm leading-relaxed uppercase text-gray-800 space-y-6">
              <p className="text-xs text-gray-500">{t('privacy.lastUpdated')}</p>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('privacy.infoWeCollect')}</h3>
                <p>{t('privacy.infoWeCollectText')}</p>
              </div>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('privacy.howWeUse')}</h3>
                <ul className="list-disc list-inside space-y-2">
                  <li>{t('privacy.useReason1')}</li>
                  <li>{t('privacy.useReason2')}</li>
                  <li>{t('privacy.useReason3')}</li>
                  <li>{t('privacy.useReason4')}</li>
                  <li>{t('privacy.useReason5')}</li>
                </ul>
              </div>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('privacy.infoSharing')}</h3>
                <p>{t('privacy.infoSharingText')}</p>
              </div>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('privacy.dataSecurity')}</h3>
                <p>{t('privacy.dataSecurityText')}</p>
              </div>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('privacy.yourRights')}</h3>
                <ul className="list-disc list-inside space-y-2">
                  <li>{t('privacy.right1')}</li>
                  <li>{t('privacy.right2')}</li>
                  <li>{t('privacy.right3')}</li>
                  <li>{t('privacy.right4')}</li>
                </ul>
              </div>

              <div className="border-2 border-black p-6 bg-gray-50 mt-8">
                <h3 className="font-black text-lg mb-4">{t('privacy.contactUs')}</h3>
                <p className="text-xs">{t('privacy.contactUsText')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
};

export default Privacy;
